<template>
  <div v-if="userInfo" class="page">

    <!-- 搜索栏 -->
    <div class="search-bar">
      <searchbar @inputfinish="research" />
    </div>

    <div class="body flex body-size-fit">
      <div class="body-left">
        <!-- 学校信息 -->
        <div class="body-left-info flex-center flex-column bg-282B80">
          <div class="body-left-info-logo">
            <el-image class=" mach-height mach-width" :src="userInfo.userType == 1?userInfo.avatar:userInfo.team.teamAvatar" fit="cover">
              <div slot="error" class="image-slot flex flex-center">
                <img class="mach-width mach-height" src="../../../../assets/icon-user-default.png">
              </div>
            </el-image>
          </div>
          <div class="body-left-info-name flex-center">
            <p v-if="userInfo.userType == 1" class="font-size-16 font-bold font-color-white">{{ userInfo.name }}</p>
            <p v-else-if="userInfo.userType == 2" class="font-size-16 font-bold font-color-white">{{ userInfo.team.teamName }}</p>
          </div>
          <div class="body-left-info-count flex-center">
            <p class="font-size-12 font-color-white">发布 {{ userInfo.collectionNumber }} 馆藏</p>
          </div>
        </div>

        <!-- 侧边栏menu -->
        <div class="body-left-menu">
          <div class="body-left-item flex-row-justify-space-between flex-row-align-center cursor" :class="textType == 'upload'?'body-left-item-sel':''" data-type="upload" data-tit="我的上传" @click="textTypeSelect">
            <div class="flex-row-align-center">
              <img class="body-left-item-icon" src="../../../../assets/icon-lib-user-upload.png" alt="">
              <p class="font-size-14 font-bold">我的上传</p>
            </div>
            <img v-if="textType == 'upload'" class="body-left-item-arrow" src="../../../../assets/icon-lib-foldup.png" alt="">
          </div>
          <div class="body-left-item flex-row-justify-space-between flex-row-align-center cursor" :class="textType == 'collection'?'body-left-item-sel':''" data-type="collection" data-tit="我的收藏" @click="textTypeSelect">
            <div class="flex-row-align-center">
              <img class="body-left-item-icon" src="../../../../assets/icon-lib-source-uncoll.png" alt="">
              <p class="font-size-14 font-bold">我的收藏</p>
            </div>
            <img v-if="textType == 'collection'" class="body-left-item-arrow" src="../../../../assets/icon-lib-foldup.png" alt="">
          </div>
          <div class="body-left-item flex-row-justify-space-between flex-row-align-center cursor" :class="textType == 'set'?'body-left-item-sel':''" data-type="set" data-tit="设置" @click="textTypeSelect">
            <div class="flex-row-align-center">
              <img class="body-left-item-icon" src="../../../../assets/icon-lib-user-set.png" alt="">
              <p class="font-size-14 font-bold">设置</p>
            </div>
            <img v-if="textType == 'set'" class="body-left-item-arrow" src="../../../../assets/icon-lib-foldup.png" alt="">
          </div>
        </div>
      </div>
      <div class="body-right flex-1">
        <div class="body-right-tit flex-row-align-center">
          <p class="font-size-30 font-bold">{{ textTit }}</p>
        </div>

        <div v-if="textType == 'upload'" class="body-right-upload">
          <!-- 上传右侧顶部menu -->
          <div class="body-right-upload-menu flex-row-align-center">
            <div v-for="item in menuList" :key="item.id" class="body-right-upload-menu-item flex-center cursor" :data-code="item.code" @click="uploadMenuSelect">
              <div class="flex body-right-upload-menu-item-border flex-row-align-center">
                <p class="font-size-14 flex-1" :class="uploadMenuSelCode==item.code?'body-right-upload-menu-item-border-sel':''">{{ item.tit }}</p>
                <div class="body-right-upload-menu-item-line" />
              </div>
            </div>
          </div>
          <sources :status="uploadMenuSelCode" />
        </div>

        <div v-else-if="textType == 'collection'" class="body-right-coll">
          <collection />
        </div>

        <div v-else-if="textType == 'set'" class="body-right-set">

          <div v-if="userInfo.userType == 1">
            <!-- 设置右侧顶部menu -->
            <div class="body-right-upload-menu flex-row-align-center">
              <div v-for="item in personMenu" :key="item.id" class="body-right-upload-menu-item flex-center cursor" :data-code="item.code" @click="uploadSetSelect">
                <div class="flex body-right-upload-menu-item-border flex-row-align-center">
                  <p class="font-size-14 flex-1" :class="uploadSetSelCode==item.code?'body-right-upload-menu-item-border-sel':''">{{ item.tit }}</p>
                  <div class="body-right-upload-menu-item-line" />
                </div>
              </div>
            </div>
            <userform :status="uploadSetSelCode" @update="updateView" />
          </div>
          <div v-else-if="userInfo.userType == 2">
            <div class="body-right-upload-menu flex-row-align-center">
              <div v-for="item in teamMenu" :key="item.id" class="body-right-upload-menu-item flex-center cursor" :data-code="item.code" @click="uploadSetSelect">
                <div class="flex body-right-upload-menu-item-border flex-row-align-center">
                  <p class="font-size-14 flex-1" :class="uploadSetSelCode==item.code?'body-right-upload-menu-item-border-sel':''">{{ item.tit }}</p>
                  <div class="body-right-upload-menu-item-line" />
                </div>
              </div>
            </div>
            <teamform :status="uploadSetSelCode" @update="updateView" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import sources from './commponents/sources.vue'
import searchModel from '../../../../models/search.js'
import collection from './commponents/collections.vue'
import userform from './commponents/userform.vue'
import teamform from './commponents/teamuserForm.vue'
import searchbar from '@/components/Searchbar.vue'
import userdata from '../../../../models/user.js'
import api from '../../../../api/auth.js'
import auth from '../../../../models/auth.js'
import { replaceUrl } from '../../../../utils/utils.js'

export default {
  name: 'User',
  components: {
    searchbar,
    sources,
    collection,
    userform,
    teamform
  },
  data() {
    return {
      textType: 'upload',
      textTit: '我的上传',
      showDelDialog: false,
      menuList: [{
        'id': 1,
        'tit': '全部',
        'code': '0'
      }, {
        'id': 2,
        'tit': '已发布',
        'code': '1'
      }, {
        'id': 3,
        'tit': '审核中',
        'code': '2'
      }, {
        'id': 4,
        'tit': '未通过',
        'code': '3'
      }],
      uploadMenuSelCode: '0',
      mouseOverIndex: -1,

      personMenu: [{
        'id': 1,
        'tit': '个人资料',
        'code': '0'
      }, {
        'id': 2,
        'tit': '修改头像',
        'code': '1'
      }, {
        'id': 3,
        'tit': '学校信息',
        'code': '2'
      }, {
        'id': 4,
        'tit': '认证绑定',
        'code': '3'
      }],

      teamMenu: [{
        'id': 1,
        'tit': '团体资料',
        'code': '0'
      }, {
        'id': 2,
        'tit': '修改头像',
        'code': '1'
      }],
      uploadSetSelCode: '0',

      reqdel: {
        length: 0,
        desc: ''
      },
      userInfo: null
    }
  },
  created() {
    const tid = this.$route.query.tid || 'ADKS'
    if (tid === 'ADKS') {
      this.requestUser()
      const code = this.$route.query.code
      if (code) {
        this.requestBindWX(code)
        replaceUrl()
      } else if (tid === 'CQU') {
        const auth_url = `https://cqu.cnmrms.com/#/user?&code=${this.$route.query.code}`
        window.location.replace(auth_url)
      } else if (tid === 'SWJTU') {
        const auth_url = `https://swjtu.cnmrms.com/#/user?&code=${this.$route.query.code}`
        window.location.replace(auth_url)
      }else if (tid === 'CNU') {
        const auth_url = `https://cnu.cnmrms.com/#/user?&code=${this.$route.query.code}`
        window.location.replace(auth_url)
      }else if (tid === 'YGYD') {
        const auth_url = `https://ygyd.cnmrms.com/#/user?&code=${this.$route.query.code}`
        window.location.replace(auth_url)
      }
      
    }
  },
  activated() {

  },
  mounted() {
    // this.requestAll()
    this.$store.dispatch('navigation/setNavigatorIndex', 4)
  },
  methods: {
    requestUser() {
      if (auth.gettoken()) {
        const that = this
        api.userInfo().then(r => {
          that.userInfo = r.data
          userdata.save(r.data)
        }).catch((error) => {
          that.$message({
            showClose: false,
            message: error.message || '绑定失败',
            type: 'success'
          })
        })
      } else {
        this.$router.push({
          path: '/login',
          query: {
            r: '/user'
          }
        })
      }
    },
    requestBindWX(code) {
      const that = this
      api.bindwx({ code: code, tenantId: this.$store.getters.tenantId }).then(r => {
        if (r.data) {
          that.$message({
            showClose: false,
            message: '绑定成功',
            type: 'success'
          })
          that.requestUser()
        }
      }).catch(error => {
        that.$message({
          showClose: false,
          message: error.message || '绑定失败',
          type: 'error'
        })
      })
    },
    textTypeSelect(e) {
      const t = e.currentTarget.dataset.type
      this.textType = t
      this.textTit = e.currentTarget.dataset.tit
    },
    uploadSetSelect(e) {
      this.uploadSetSelCode = e.currentTarget.dataset.code
    },
    uploadMenuSelect(e) {
      this.uploadMenuSelCode = e.currentTarget.dataset.code
    },
    sourceOver(e) {
      this.mouseOverIndex = e.currentTarget.dataset.index
    },
    showDelDialogView() {
      this.showDelDialog = true
    },
    requestDelsource() {
      this.showDelDialog = false
    },
    inputChange(e) {
      this.reqdel.length = e.target.value.length
      this.reqdel.desc = e.target.value
    },
    updateView() {
      // this.userInfo = userdata.getUserData()
      this.requestUser()
    },
    research() {
      searchModel.viewData = { params: null, display: null, type: '' }
      this.$router.push({ name: 'Collection' })
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style scoped>
  .page {
    padding-top: 160px;
    padding-bottom: 100px;
    min-height: 800px;
  }

  .body-left {
   width: 280px;
   padding-top: 26px;
 }

  .body-right {
    margin-left: 40px;
 }

 .body-left-info {
   width: 280px;
   height: 166px;
 }

 .body-left-info-logo {
   width: 64px;
   height: 64px;
   border-radius: 50%;
   background-color: #fff;
   overflow: hidden;
 }

 .body-left-info-name {
   margin-top: 11px;
   height: 24px;
 }

 .body-left-info-count {
   height: 20px;
 }

 .body-left-info-count p {
   opacity: 0.5;
 }

 .body-left-menu {
   margin-top: 20px;
 }

 .body-left-item {
   height: 50px;
   border-bottom: 1px solid #fff;
   background-color:#F3F4F9;
   padding-left: 20px;
   padding-right: 15px;
 }

 .body-left-item:last-child{
   border: none;
 }

 .body-left-item-sel {
   background-color: #D3D6E7;
 }

 .body-left-item-icon {
   margin-right: 10px;
 }

 .body-left-item-arrow {
   transform: rotate(90deg);
 }

 .body-right-tit {
   height: 84px;
 }

 .body-right-upload-menu {
   height: 54px;
   border: 1px solid #F3F4F9;
 }

 .body-right-upload-menu-item {
   height: 30px;
 }

 .body-right-upload-menu-item-border {
   height: 16px;
   width: 100%;
   border-right: 1px solid #C8CFE1;
 }

 .body-right-upload-menu-item:last-child .body-right-upload-menu-item-border {
   border: none;
 }

 .body-right-upload-menu-item p {
   padding: 8px 20px;
 }

 .body-right-upload-menu-item-border-sel {
   color: #264480;
   font-weight: bold;
 }

 .body-right-upload-list {
   padding-top: 8px;
 }

 .body-right-upload-list-item-img {
   width: 146px;
   padding-top: 32px;
   margin-right: 26px;
 }

 .body-right-upload-list-item-img img {
   width: 146px;
   height: 98px;
   background-color: bisque;
 }

 .body-right-upload-list-item-info {
   padding-top: 24px;
 }

 .body-right-upload-list-item-info-tit {
   height: 30px;
 }

 .body-right-upload-list-item-info-desc {
   height: 40px;
 }

 .body-right-upload-list-item-info-mark {
   margin-top: 10px;
 }

 .body-right-upload-list-item-info-mark-item {
   height: 24px;
   padding: 6px 8px;
   margin-right: 10px;
 }

 .status-success {
   background-color: #F3F4F9;
 }

 .status-success p {
   color: rgba(0, 0, 0, 0.5);
 }

 .status-fail {
   background-color: rgba(205, 46, 46,0.1)
 }

 .status-fail p {
   color: #CD2E2E;
 }

 .status-ing {
   background-color: rgba(211, 160, 48, 0.2)
 }

 .status-ing p {
   color: #D3A030;
 }

.body-right-upload-list-item-info-mark-del p {
  opacity: 0.5;
}

</style>
